module.exports = __webpack_public_path__ + "img/PinPointLogo.c3f83019.png";